import { render, staticRenderFns } from "./TabsItem.vue?vue&type=template&id=39e20f65&scoped=true&"
import script from "./TabsItem.vue?vue&type=script&lang=js&"
export * from "./TabsItem.vue?vue&type=script&lang=js&"
import style0 from "./TabsItem.vue?vue&type=style&index=0&id=39e20f65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e20f65",
  null
  
)

export default component.exports